import React from 'react';
import './LoadingSpinner.css';

interface LoadingSpinnerProps {
    message?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ message = "Carregando..." }) => {
    return (
        // Apenas esta classe foi alterada
        <div className="spinner-wrapper">
            <div className="spinner-container">
                <div className="loading-spinner"></div>
                <p className="spinner-text">{message}</p>
            </div>
        </div>
    );
};

export default LoadingSpinner;